export default "__VITE_ASSET__Dv$ptdIL__"